import { ScaleLinear } from 'd3-scale';
import { useContext, createContext } from 'react';

interface RangeLegendScaleContextProps {
  scale: ScaleLinear<number, number>;
}

export const RangeLegendScaleContext =
  createContext<RangeLegendScaleContextProps>(
    {} as RangeLegendScaleContextProps,
  );

export const useScale = () => useContext(RangeLegendScaleContext);
